// Set webpack asset host at runtime. Must be imported at top of entrypoints.
import '../helpers/asset_host';
import App from '../packages/partners_signup/App';
import reactRender from '../helpers/react_render';

reactRender(App);
